import { gql } from "apollo-boost";
import React from 'react'
import { Subscription } from "react-apollo";

import DailyLineChart from 'pages/manage/events/detail/DailyLineChart'
import { Card } from 'reactstrap'
import { fetchGraphQL } from 'services/graphql/GraphQL';

import { ContentLoader } from '../../../../components/common/loader/ContentLoader';


export default class RevenueGraph extends React.Component<
    { [label: string]: any }, { [label: string]: any }> {

    constructor(props) {
        super(props)
        this.state = {
            loading: true,
            tickets: [],
            updateString: 0
        }
        this.reloadData = this.reloadData.bind(this);
    }

    public reloadData(e: any) {
        fetchGraphQL(
            `
            query {
                ticket {
                    getByEventId(eventId:"${this.props.eventId}") {
                        status
                        totalPrice
                        totalPlatformFees
                        totalProcessingFees
                        promoterId
                        boughtAt
                    }
                }
            }
            `
        ).then(ress => {
            const tickets = ress.ticket != null ? ress.ticket.getByEventId : [];
            this.setState({ tickets, isLoadingTickets: false, loading: false, updateString: e });
        });
        return undefined;
    }

    public componentDidMount() {
        fetchGraphQL(
            `
            query {
                ticket {
                    getByEventId(eventId:"${this.props.eventId}") {
                        status
                        totalPrice
                        totalPlatformFees
                        totalProcessingFees
                        promoterId
                        boughtAt
                    }
                }
            }
            `
        ).then(ress => {
            const tickets = ress.ticket != null ? ress.ticket.getByEventId : [];
            this.setState({ tickets, isLoadingTickets: false, loading: false });
        }); // End of tickets fetch

    }

    public render() {
        const currency = this.props.currency ? this.props.currency : 'USD'
        const ticketPurchase = gql`
            subscription {
                ticketPurchase(eventIds:"${this.props.eventId}")
            }
		`;
        if (this.state.tickets.length !== 0) {
            return (
                <Card>
                    <Subscription subscription={ticketPurchase}>
                        {({ data }) => {
                            if (data !== undefined && data !== null && data.ticketPurchase !== null) {
                                if (data.ticketPurchase !== this.state.updateString) {
                                    return <img height={0} width={0} onLoad={this.reloadData(data.ticketPurchase)} style={{ display: 'none' }} />
                                }
                                return null;
                            }
                            return null;
                        }}
                    </Subscription>
                    <div style={{ paddingLeft: '5%', paddingRight: '5%' }}>
                        <p />
                        <h3 style={{ width: '100%', textAlign: 'center' }} className={this.props.onSale ? 'sexyBlack' : 'pause-gray'}>Daily Sales Timeline</h3>
                        <p />
                        <ContentLoader isLoading={this.state.loading}>
                            <DailyLineChart tickets={this.state.tickets} isHost={this.props.isHost} currency={currency} />
                        </ContentLoader>
                        <p><br /></p>
                    </div>
                </Card>
            )
        } else {
            return null
        }
    }

}


// WEBPACK FOOTER //
// ./src/pages/manage/events/detail/RevenueGraph.tsx